import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "forgot-password" }
const _hoisted_2 = { class: "input-group" }
const _hoisted_3 = { class: "input-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSvg = _resolveComponent("BaseSvg")!
  const _component_BaseInput = _resolveComponent("BaseInput")!
  const _component_BaseAlert = _resolveComponent("BaseAlert")!
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      href: "#",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToLogin && _ctx.goToLogin(...args)))
    }, [
      _createVNode(_component_BaseSvg, {
        class: "back-icon",
        icon: "arrow/arrow-left"
      }),
      _cache[3] || (_cache[3] = _createTextVNode("Back to login "))
    ]),
    _cache[5] || (_cache[5] = _createElementVNode("h4", null, "Forgot password?", -1)),
    _cache[6] || (_cache[6] = _createElementVNode("p", null, "Please enter your registered email address in the box below to receive your password reset instructions.", -1)),
    _createElementVNode("form", {
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_BaseInput, {
          modelValue: _ctx.v$.email.$model,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.email.$model) = $event)),
          name: "email",
          hasError: _ctx.v$.email.$error,
          errors: _ctx.v$.email.$errors,
          type: "email",
          label: "Enter your email address",
          valid: !_ctx.v$.email.$invalid
        }, null, 8, ["modelValue", "hasError", "errors", "valid"])
      ]),
      (_ctx.success)
        ? (_openBlock(), _createBlock(_component_BaseAlert, {
            key: 0,
            type: "success",
            message: "Email sent successfully"
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_BaseButton, {
          class: "submit-btn",
          loading: _ctx.loading
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [
            _createTextVNode("Send")
          ])),
          _: 1,
          __: [4]
        }, 8, ["loading"])
      ])
    ], 32)
  ]))
}